
<div class="ac-color animated {{options.stepDirectionClass}}" style="padding:1rem;">
  <!--START PARTIAL AMOUNT-->
  <div class="my-panel mb-1 no-shadow">
    <div class="my-panel-body">
      <div class="_panel-title"><div>{{'partial_payment_title' | translate}}</div></div>
      <div class="partial-amount-display">
        <div class="_inner" (click)="setSplitPaymentOption(manualPartial)">
          <div class="edit btn-bordered-image _only me-3">
            <div class="image-icon-badge"><mat-icon svgIcon="pen"></mat-icon></div>
          </div>
          <div class="_val">{{partialPayment.amount | lcurrency}}</div>
          <div class="_spacer"></div>
        </div>
      </div>
      <div class="pmamount-rows">
        @for (opt of splitPaymentOptions; track opt) {
          <button type="button" class="btn-bordered"
            [ngClass]="{'active': opt.isText || opt === partialPayment}"
            (click)="setSplitPaymentOption(opt)"
            [disabled]="opt.disabled">
            <div>
              <div [ngClass]="{'text-xs': opt.isText}">{{opt.text}}</div>
              @if (!opt.isManual) {
                <div class="text-xs">{{opt.subText | lcurrency:currencyFormat}}</div>
              }
            </div>
          </button>
        }
      </div>
    </div>
  </div>
  <!--END PARTIAL AMOUNT-->
  <!--START OTHER METHODS-->
  @if (appService.regionArgs.enableByItems && !$storage.check) {
    <div class="my-panel mb-base no-shadow">
      <div class="my-panel-body">
        <!--<div class="_panel-title"><div>{{'partial_payment_calcs_title' | translate}}</div></div>-->
        <div class="pmamount-rows">
          <button type="button" class="btn-bordered-image text-base" (click)="payByOffers()" style="width:50%">
            <div class="image-icon-badge me-2"><mat-icon svgIcon="list_check"></mat-icon></div>
            <div>{{'pay_by_items' | translate}}</div>
          </button>
          <button type="button" class="btn-bordered-image text-base" (click)="payByDiners()" style="width:50%">
            <div class="image-icon-badge me-2"><mat-icon svgIcon="users"></mat-icon></div>
            <div>{{'pay_by_diners' | translate}}</div>
          </button>
        </div>
      </div>
    </div>
  }
  <!--END OTHER METHODS-->
  <!--START GRATUITY-->
  @if ($storage.enableGratuity) {
    <div class="my-panel no-shadow">
      <div class="my-panel-body">
        <div class="_panel-title">
          <div>{{'gratuity' | translate}}</div>
        </div>
        @if ($storage.order.autoGratuity) {
          <div class="text-center text-info pb-2 position-relative" style="top:-5px">
            {{appService.translate('service_charges_applied', {name: $storage.order.autoGratuity.name})}}: {{$storage.order.autoGratuity.amount | lcurrency:'1.2-2'}}
          </div>
        }
        <div class="gratuity-rows">
          <!--SEATED GRATUITY-->
          @if (tipBehavior == 'P') {
            @for (opt of $storage.gratuities; track opt) {
              <button type="button" class="btn-bordered"
                [ngClass]="{'active': slectedGratuity == opt}"
                (click)="setGratuity('p', opt)">
                <div >{{opt}}%</div>
                <div class="info">{{tabitPayService.calculateGratuityFromPercentage(opt, partialPayment.amount) | lcurrency:currencyFormat}}</div>
              </button>
            }
          }
          <!--end SEATED GRATUITY-->
          <!--COURIER GRATUITY-->
          @if (tipBehavior == 'A') {
            @for (opt of $storage.gratuities; track opt) {
              <button type="button" class="btn-bordered"
                [ngClass]="{'active': slectedGratuity == opt}"
                (click)="setFixedValGratuity(opt)">
                <div >{{opt | lcurrency:'1.0-0'}}</div>
              </button>
            }
          }
          <!--end COURIER GRATUITY-->
        </div>
        <div class="gratuity-rows">
          <button type="button" (click)="setManualGratuity('v')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'v'}">
            <span>{{ 'amount' | translate}} {{appService.regionArgs.currency}}</span>
            @if (slectedGratuity == 'v') {
              <div class="info _lg">{{gratuity.amount | lcurrency:currencyFormat}}</div>
            }
          </button>
          <button type="button" (click)="setManualGratuity('p')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'p'}">
            <span>{{ 'percent' | translate}} %</span>
            @if (slectedGratuity == 'p') {
              <div class="info _lg d-flex align-items-center justify-content-center"><span>{{gratuity.percent | number:'1.0-2'}}%</span><span class="ms-2">{{gratuity.amount | lcurrency:currencyFormat}}</span></div>
            }
          </button>
        </div>
        @if (gratuity.amount && $storage.gratuityPAWarning) {
          <div class="mt-1 text-accent text-center font-semi-bold text-xs animated faster slideInUp">
            <div>{{$storage.gratuityPAWarning}}</div>
          </div>
        }
      </div>
    </div>
  }
  <!--END GRATUITY-->


</div>

<div class="ac-color p-3 pb-4 fixed-bottom">
  <button mat-raised-button color="accent" class="lg main-continue-btn" type="button" (click)="submit()">
    <div class="_inner">
      <span>{{"continue" | translate}}</span>
      @if (total) {
        <b>{{(partialPayment.amount  + gratuity.amount) | lcurrency}}</b>
      }
      <div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
    </div>
  </button>
</div>
